//information
export const SET_INFORMATION_DATA: any = 'SET_INFORMATION_DATA';
export const SET_INFORMATION_EDIT_DATA: any = 'SET_INFORMATION_EDIT_DATA';
export const SET_INFORMATION_ERROR_DATA: any = 'SET_INFORMATION_ERROR_DATA';
export const CLEAR_INFORMATION_DATA: any = 'CLEAR_INFORMATION_DATA';
